import { render, staticRenderFns } from "./editUrl.vue?vue&type=template&id=c09db67c&scoped=true&"
import script from "./editUrl.vue?vue&type=script&lang=js&"
export * from "./editUrl.vue?vue&type=script&lang=js&"
import style0 from "./editUrl.vue?vue&type=style&index=0&id=c09db67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09db67c",
  null
  
)

export default component.exports